import type { IndustryPackDefinition } from '../../../domain/industry/types';
import { edtechPack } from './edtech.pack';
import { fintechPack } from './fintech.pack';
import { healthtechPack } from './healthtech.pack';
import { insurtechPack } from './insurtech.pack';
import { retailEcomPack } from './retail_ecom.pack';
import { saasB2bPack } from './saas_b2b.pack';
import { sandboxPack } from './sandbox.pack';

export const INDUSTRY_PACK_REGISTRY: IndustryPackDefinition[] = [
  fintechPack,
  healthtechPack,
  saasB2bPack,
  insurtechPack,
  edtechPack,
  retailEcomPack,
  sandboxPack,
];

export {
  fintechPack,
  healthtechPack,
  saasB2bPack,
  insurtechPack,
  edtechPack,
  retailEcomPack,
  sandboxPack,
};